module.exports = __webpack_public_path__ + "img/stena26.74ee3d9c.jpg";